// React and hooks
import { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';

// Material UI components
import { Grid, TextField, MenuItem, Button, CircularProgress, Dialog, DialogContent, DialogTitle, FormControl, InputLabel } from '@mui/material';

// Icons
import { CloseCircle } from 'iconsax-react';

// Third-party libraries

import { toast } from 'react-toastify';

// Custom hooks and utilities
import { useAuth, useCompany } from 'hooks';
import API from 'services/AxiosConfig';
import { formatDate, formatName } from 'lib';
import { FormInput } from 'components';
interface AwardManagementInputProps {
    activity: string,
}
interface AddModalProps {
    isOpen: boolean;
    onClose: () => void;
    data: any; // Replace 'any' with the actual data type if known
    getData: (refresh: boolean) => void;
    handleEmailOpen: () => void;
    title: string;
    url: string;
    checkDuplicateEntry: (name: string) => boolean;
}
const AddModal = ({ isOpen, onClose, data, getData, handleEmailOpen, title = "", url, checkDuplicateEntry }: AddModalProps) => {
    const { user } = useAuth()

    const [isLoading, setIsLoading] = useState(false);
    const { locations } = useCompany()
    const initialValues: AwardManagementInputProps = {
        activity: data ? data.award.value : "",
    };


    const validationSchema = yup.object({
        activity: yup.string().typeError('').required('Input requires')
    });

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            data ? editFormHandler(values) : createNewData(values);
            //getData()
        },
    });

    const deletedata = () => {
        // setIsLoading(true);
        toast.loading('Deleting ...');
        // API.delete(`vendors/${data.id}`)
        //     .then((rsp => {
        //         setIsLoading(false);
        //         toast.dismiss()
        //         if (rsp.data.success) {
        //             toast.success('Successfully deleted "' + nm + '".');
        //             getData()
        //             onClose();
        //         }
        //     }))
        //     .catch((error) => {
        //         setIsLoading(false);
        //         toast.dismiss();
        //         toast.error('Failed to delete "' + nm + '".');
        //         console.error(error);
        //     });
    }

    const editFormHandler = (values: any) => {
        toast.loading(`Updating ${title}...`);
        setIsLoading(true);
        API.put(`${url}/activity-type/${data.id}`, { ...values, userId: user?._id })
            .then((rsp) => {
                toast.dismiss();
                setIsLoading(false);
                if (rsp.data.success) {
                    toast.success(`Successfully updated ${title}.`);
                }
                getData(true);
                formik.resetForm()
                onClose();
            })
            .catch((error) => {
                toast.dismiss();
                setIsLoading(false);
                toast.error(`Failed to edit ${title}.`);
                console.error(error);
            });
    };

    const createNewData = (values: any) => {
        let isReferral = null
        if (title === 'Referral Partners Activity') {
            isReferral = true
        }
        if (title === 'Prospect Activity') {
            isReferral = false
        }
        if (checkDuplicateEntry(values.activity)) {
            toast.error(`${title} already exists.`);
            return;
        }
        setIsLoading(true);
        API.post(`${url}/activity-type`, { ...values, userId: user?._id, isReferral: isReferral })
            .then((rsp) => {
                setIsLoading(false);
                if (rsp.data.success || rsp.data.status === true) {
                    toast.success(`Successfully added ${title}.`);
                }
                getData(true);
                formik.resetForm();
                onClose();
            })
            .catch((error) => {
                setIsLoading(false);
                toast.error(`Failed to add ${title}.`);
                console.error(error);
            });
    };
    return (
        <>
            <Dialog open={isOpen} onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}>
                <div className="cancel-icon" style={{ padding: '10px 5px' }}>
                    <DialogTitle className="main-model-heading">{(data ? "Edit " : "Add ") + title}</DialogTitle>
                    <CloseCircle onClick={() => {
                        onClose()
                        formik.resetForm()
                    }}
                        className="pointer-icon"/>
                </div>
                <hr className="hr-tag"></hr>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={3} className="notes-modal">
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth variant="outlined">
                                <FormInput
                                    name="activity"
                                    label={title}
                                    value={formik.values.activity}
                                    onChange={formik.handleChange}
                                    error={formik.touched.activity && Boolean(formik.errors.activity)}
                                    helperText={formik.touched.activity && formik.errors.activity}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    {isLoading ?
                        <>
                            <Grid container paddingTop={1} justifyContent="center">
                                <CircularProgress size={'28px'} />
                            </Grid>
                        </> :
                        <>
                            <Grid px={3} container spacing={2} justifyContent="space-between">
                                <Grid item gap={1} sx={{ display: 'flex' }}>
                                    {/* {
                                        data ?
                                            <>
                                                <Button color="error" variant="contained" onClick={deletedata}>Delete</Button>
                                            </>
                                            :
                                            <></>
                                    } */}
                                </Grid>
                                <Grid item gap={1} sx={{ display: 'flex' }}>
                                    <Button variant="outlined" onClick={() => {
                                        onClose()
                                        formik.resetForm()
                                    }}>
                                        Close
                                    </Button>
                                    <Button type="submit" variant="contained" color="primary">Submit</Button>
                                </Grid>
                            </Grid>
                        </>
                    }
                </form>
                <DialogContent>{/* Add your form or content for the modal here */}</DialogContent>
            </Dialog>
        </>
    );
};

export default AddModal;
